$(function () {
    $(".fancybox").fancybox({
        padding: 0,
        type: 'iframe',
        width: 900,
        height: 550,
        aspectRatio: true,
        openEffect: 'elastic',
        closeEffect: 'elastic',
        iframe: {
            preload: false
        }
    });
});
